<template>
	<DebugModeComponent v-if="debugData != undefined" :debugData="debugData" />
	<NavigationComponent :navigationData="sectionData" :mainSettings="mainSettings" />
	<template v-for="(section, index) in sectionData" :key="index">
		<TitleComponent :titleData="sectionData[index]" :index="index" v-if="section.type == 'title'"
			isMultiblock="false" />
		<FactsComponent :factsData="sectionData[index]" :index="index" v-else-if="section.type == 'data'"
			isMultiblock="false" />
		<GalleryComponent :pictureData="sectionData[index]" :index="index" v-else-if="section.type == 'pictures'"
			isMultiblock="false" />
		<FreetextComponent :freetextData="sectionData[index]" :index="index" v-else-if="section.type == 'freeTexts'"
			isMultiblock="false" />
		<FileComponent :fileData="sectionData[index]" :index="index" v-else-if="section.type == 'files'"
			isMultiblock="false" />
		<EnergyDataComponent :energyData="sectionData[index]" :index="index" v-else-if="section.type == 'energyData'"
			isMultiblock="false" />
		<LayoutComponent :layoutData="sectionData[index]" :index="index" v-else-if="section.type == 'layout'"
			isMultiblock="false" />
		<ContactPersonComponent :contactPersonData="sectionData[index]" :mainSettings="mainSettings" :index="index"
			v-else-if="section.type == 'contactPerson'" isMultiblock="false" />
		<VirtualTour :virtualTourData="sectionData[index]" :index="index" v-else-if="section.type == 'virtualTour'"
			isMultiblock="false" />
		<TextComponent :textData="sectionData[index]" :index="index" v-else-if="section.type == 'text'"
			isMultiblock="false" />
		<LocationComponent :locationData="sectionData[index]" :index="index" v-else-if="section.type == 'maps'"
			isMultiblock="false" />
		<VideoComponent :videoData="sectionData[index]" :index="index" v-else-if="section.type == 'video'"
			isMultiblock="false" />
		<UnitList :unitData="sectionData[index]" :index="index" v-else-if="section.type == 'unitList'"
			isMultiblock="false" />
		<MultiBlock :multiData="sectionData[index]" :index="index" v-else-if="section.type == 'combo'"
			isMultiblock="false" />
		<FeedbackComponent :feedbackData="sectionData[index]" :index="index" v-else-if="section.type == 'contact'"
			isMultiblock="false" />
	</template>
	<FooterComponent :footerData="mainSettings" :index="index" v-if="isLoaded == true" />
</template>

<script>
import NavigationComponent from "./NavigationComponent.vue";
import TitleComponent from "./TitleComponent.vue";
import FactsComponent from "./FactsComponent.vue";
import GalleryComponent from "./GalleryComponent.vue";
import FreetextComponent from "./FreetextComponent.vue";
import FileComponent from "./FileComponent.vue";
import EnergyDataComponent from "./EnergyDataComponent.vue";
import LayoutComponent from "./LayoutComponent.vue";
import ContactPersonComponent from "./ContactPersonComponent.vue";
import VirtualTour from "./VirtualTour.vue";
import TextComponent from "./TextComponent.vue";
import FooterComponent from "./FooterComponent.vue";
import LocationComponent from "./LocationComponent.vue";
import VideoComponent from "./VideoComponent.vue";
import UnitList from "./UnitList.vue";
import MultiBlock from "./MultiBlock.vue";
import DebugModeComponent from "../DebugModeComponent.vue";
import FeedbackComponent from "../FeedbackComponent.vue";

export default {
	components: {
		NavigationComponent,
		TitleComponent,
		FactsComponent,
		GalleryComponent,
		FreetextComponent,
		FileComponent,
		EnergyDataComponent,
		LayoutComponent,
		ContactPersonComponent,
		VirtualTour,
		TextComponent,
		FooterComponent,
		LocationComponent,
		VideoComponent,
		UnitList,
		MultiBlock,
		DebugModeComponent,
		FeedbackComponent
	},

	props: {
		sectionData: {
			type: Object,
		},
		mainSettings: {
			type: Object,
		},
		isMultiblock: {
			type: String
		},
		debugData: {
			type: Object
		}
	},

	data() {
		return {
			isLoaded: false
		}
	},
	methods: {
		loaded() {
			this.isLoaded = true;
		}
	},
	mounted() {
		this.loaded();
	}
};
</script>